
export const getIndexOfObjectProperty = (object, property) => {
    if(object[property]) {
        let index = 0;
        for (let prop in object) {
            if(property === prop) {
                break;
            }
            else {
                index++;
            }
        }
        return index;
    }
    return undefined;
}

export const getArraysOfParameter = (array, param) => {
    if (Array.isArray(array)) {
        if (array.length > 0) {
            return array.map(item => {
                return item[param]
            })
        }
        return []
    }
    return array
}

export const fillDefaultData = (data, defaultData) => {
  if (!data || !data.length) {
    return defaultData;
  }

  return data;
}
